<div class="modal-header bg-dark text-white">
  <h4 class="modal-title pull-left">{{title}}</h4>
  <button type="button" class="close pull-right text-white" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-row">
    <div class="form-group row col-md-6">
      <label class="col-2 col-form-label">Von</label>
      <div class="col-10">
        <input bsDatepicker type="text" placeholder="Startdatum" class="form-control" [(ngModel)]="filter.startdate"
          [bsConfig]="{ adaptivePosition: true, selectFromOtherMonth: true }" [dateCustomClasses]="dateCustomClasses">
      </div>
    </div>
    <div class="form-group row col-md-6">
      <label class="col-2 col-form-label">Bis</label>
      <div class="col-10">
        <input bsDatepicker type="text" placeholder="Enddatum" class="form-control" [(ngModel)]="filter.enddate"
          [bsConfig]="{ adaptivePosition: true, selectFromOtherMonth: true }" [dateCustomClasses]="dateCustomClasses">
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group row col-md-6">
      <label class="col-2 col-form-label">Bezirk</label>
      <div class="col-10">
        <app-setting-dropdown class="col" name="district" label="Bezirke" setting="Bezirke" unset="- Bezirk -"
          [inline]="true" [showID]="true" [(ngModel)]="filter.district"></app-setting-dropdown>
      </div>
    </div>
    <div class="form-group row col-md-6">
      <label class="col-2 col-form-label">Gau</label>
      <div class="col-10">
        <app-setting-dropdown class="col" name="gau" label="Gaue" setting="Gaue" unset="- Gau -" [inline]="true"
          [showID]="true" [(ngModel)]="filter.gau"></app-setting-dropdown>
      </div>
    </div>
  </div>
  <!-- Let's hide this field as long as we do not have any other type than course -->
  <div class="form-group row d-none">
    <label class="col-sm-2 col-form-label">Typ</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.type">
        <option value="course">Lehrgänge</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Region</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.region">
        <option value="">- Kennung -</option>
        <option [value]="item.id" *ngFor="let item of regions">{{item.id}} - {{item.title}}</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Bereich</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.area">
        <option value="">- Bereich -</option>
        <option [value]="item.id" *ngFor="let item of areas">
          {{item.id}} - {{item.title}}
        </option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Förderung</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.supportMeasure">
        <option value="">- Förderung -</option>
        <option [value]="measure.id" *ngFor="let measure of supportMeasures">{{measure.id}} - {{measure.title}}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Ort</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.place">
        <option value="">- Ort -</option>
        <option [value]="place.id" *ngFor="let place of places">{{place.id}} - {{place.title}}</option>
      </select>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Status</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.status">
        <option value="">- Status -</option>
        <option [value]="state" *ngFor="let state of states">{{state|translate}}</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Lehrgangsart</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.form">
        <option value="0">- Lehrgangsart -</option>
        <option [ngValue]="item.id" *ngFor="let item of forms">{{item.name}}</option>
      </select>
    </div>
  </div>
  <app-setting-dropdown name="chapter" label="Kapitel" setting="Kapitelauswahl" unset="- Kapitel -"
    [(ngModel)]="filter.chapter"></app-setting-dropdown>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Dateiformat</label>
    <div class="col-sm-10">
      <select class="form-control" [(ngModel)]="filter.fileFormat">
        <option value="csv">CSV für Excel</option>
        <option value="xlsx">XLSX für Excel</option>
        <option value="xml">XML</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <label class="col-sm-2 col-form-label">Felder</label>
    <div class="col-sm-10">
      <!-- <button type="button" class="btn btn-outline-primary mr-1" (click)="applyFieldList(item)"
        *ngFor="let item of exportFields">{{item.name}}</button>
      <br> -->
      <div class="btn-group" btnRadioGroup>
        <label class="btn btn-primary" [(ngModel)]="fieldsPreselect" (click)="applyFieldList(item)"
          btnRadio="{{item.name}}" tabindex="0" role="button" *ngFor="let item of exportFields">{{item.name}}</label>
      </div>
      <br>
      <button type="button" class="btn btn-outline-primary mt-2" (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
        Felder einzeln auswählen
      </button>
      <div class="mt-2" [collapse]="isCollapsed">
        <div class="card">
          <div class="card-body">
            <div class="form-check" *ngFor="let item of availableFields; let i = index">
              <input type="checkbox" class="form-check-input" value="{{item?.id}}" id="{{'field' + i}}"
                [checked]="isFieldSelected(item?.id)" (change)="selectField(item?.id)">
              <label class="form-check-label" for="{{'field' + i}}">
                {{item?.title || item}}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="download()">Download</button>
  <button type="button" class="btn btn-danger" (click)="bsModalRef.hide()">{{closeBtnName}}</button>
</div>
